import { iChainsFilters } from "@models/ChainsFilters";
import { components } from "@apiSchema";
import { getAlcoholString } from "@models/ChainBase";
import Http from '../fetch';
import { useMemo, useState } from "react";
import useNotification from "../hooks/useNotification";

export function getFiltersForExport (
    allFilters: iChainsFilters,
    selectedFilters: iChainsFilters,
    searchQuery: string = '',
): components["schemas"]["ChainFilterData"] {
    const {
        minUnits,
        maxUnits,
        states: selectedStates,
        menuTypes: selectedMenuTypes,
        metros: selectedMetros,
        segments: selectedSegments,
        alcohol: selectedAlcohol,
    } = selectedFilters;

    const {
        states: allStates,
        menuTypes: allMenuTypes,
        metros: allMetros,
        segments: allSegments,
        alcohol: allAlcohol,
    } = allFilters;

    return {
        searchQuery,
        unitsTo: maxUnits,
        unitsFrom: minUnits,
        states: selectedStates.length === allStates.length ? [] : selectedStates,
        segments: selectedSegments.length === allSegments.length ? [] : selectedSegments,
        metros: selectedMetros.length === allMetros.length ? [] : selectedMetros,
        menuTypes: selectedMenuTypes.length === allMenuTypes.length ? [] : selectedMenuTypes,
        alcohols: selectedAlcohol.length === allAlcohol.length ? [] : selectedAlcohol.map(getAlcoholString),
    };
}

async function getChainsExport(chainsIds: number[], filters: components["schemas"]["ChainFilterData"]): Promise<any> {
    const reqData: components["schemas"]["ChainsFilter"] = {
        ids: chainsIds,
        filter: filters,
    };
    return await Http.downloadFileXHR(
        'POST',
        'export chains list',
        {},
        JSON.stringify(reqData)
    );
}

export function useChainsExport(
    chainsIds: number[],
    allFilters: iChainsFilters,
    selectedFilters: iChainsFilters,
    searchQuery: string = '',
) {
    const [isDownloading, setIsDownloading] = useState(false);
    const notification = useNotification();
    const filtersForExport = useMemo(
        () => getFiltersForExport(allFilters, selectedFilters, searchQuery),
        [allFilters, selectedFilters, searchQuery]
    );

    const requestExportChains = async (type: 'Firefly Chains' | 'Places') => {
        setIsDownloading(true);
        await getChainsExport(chainsIds, filtersForExport);
        setIsDownloading(false);
        notification.handleShowNotification();
    };

    return {
        requestExportChains,
        isDownloading,
        isNotificationShow: notification.isOpen
    };
}